const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkDevice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    style: {
      fillRule: "nonzero"
    },
    d: "M38,17l-28,0c-2.2,0 -4,1.8 -4,4l0,8c0,2.2 1.8,4 4,4l28,0c2.2,0 4,-1.8 4,-4l0,-8c0,-2.2 -1.8,-4 -4,-4Zm-22,10l-4,0l0,-4l4,0l0,4Zm7,0l-4,0l0,-4l4,0l0,4Zm7,0l-4,0l0,-4l4,0l0,4Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkDevice);
export default __webpack_public_path__ + "static/media/network-device.3f1bd06c57b46c27bf458222ce4575ca.svg";
export { ForwardRef as ReactComponent };